import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/live-hair-color"
    path="business/products/live-hair-color"
    element={<AsyncPage />}
  />,
];
